// extracted by mini-css-extract-plugin
module.exports = {"feature-cards":"WebtraderFeatures_feature-cards__sgynK","no-icons":"WebtraderFeatures_no-icons__NpodR"};